/** Pathfinder brand tokens — single source of truth for colors, fonts, spacing */

const T = {
  // Primary palette
  indigo: "#290569",
  purple: "#460ABA",
  charcoal: "#4F4F4F",
  gray100: "#F0F0F0",
  gray200: "#E2E2E2",
  gray300: "#D0D0D0",
  gray400: "#9A9A9A",
  white: "#FFFFFF",

  // Status colors
  green: "#1A9E5C",
  greenBg: "#E8F8F0",
  amber: "#D4850A",
  amberBg: "#FFF6E6",
  red: "#C93B3B",
  redBg: "#FEF0F0",

  // Logo gradient
  gradStart: "#B600A3",
  gradEnd: "#380095",

  // Typography
  font: "'Poppins', sans-serif",
  serif: "'PT Serif', serif",

  // Radii
  radius: 10,
  radiusSm: 6,

  // Shadows
  shadow: "0 2px 12px rgba(41,5,105,0.08)",
  shadowLg: "0 8px 32px rgba(41,5,105,0.12)",
};

export default T;
